<template>
  <div class="container" v-show="finishGetData || getEventData">
    <div class="container__list" v-if="(isEventData && hasEventPolicesData) || isLoadingData">
      <div class="container__list-event-left">
        <div class="gr-button-list">
          <lego-segment-wrapper
            v-model="selectedValue"
            style="margin-left: 10px; margin-right: 10px"
          >
            <lego-segment-button value="1" @click="fetchEventAll" v-lego-tooltip="$t('label.all')">
              <lego-icon
                iconType="df"
                icon="lis_all"
                size="16"
                :class="selectedValue == 1 ? 'active' : ''"
              />
            </lego-segment-button>
            <lego-segment-button
              value="2"
              @click="fetchEventActive"
              v-lego-tooltip="$t('label.active')"
            >
              <lego-icon
                iconType="df"
                icon="lis_active"
                size="16"
                :class="selectedValue == 2 ? 'active' : ''"
              />
            </lego-segment-button>
          </lego-segment-wrapper>
          <div class="btn-event-level">
            <EventLevel v-model="eventLevelActive" />
          </div>
        </div>

        <div class="events" :style="lstEventState.length ? '' : 'height:98%'">
          <c-scroll
            style="height: 618px; width: 100%; padding-right: 24px"
            ref="cscroll"
            v-if="lstEventState.length"
          >
            <Event
              v-for="(item, index) in lstEventState"
              ref="listEventState"
              :key="index"
              :item="item"
              :isMonTargetEvent="true"
              :isCheck="item.check"
              @click.stop="onClickDetail(item, index)"
            />
          </c-scroll>
          <div v-else class="event-no-data">
            <img src="@/assets/img/scmp/no_data.png" />
            <span>{{ t('label.noData') }}</span>
          </div>
        </div>
      </div>
      <div class="container__detail-event">
        <div
          v-if="
            ((isEventData && hasEventPolicesData && isLoadingData && lstEventState.length) ||
              modalParam.eventId) &&
            lstEventState.length
          "
        >
          <MonTargetEventDetailPopup
            v-if="isEventData && hasEventPolicesData && isLoadingData"
            :params="modalParam"
            :pTitle="t('title.eventDetail')"
            :searchDate="searchDate"
            parentClass="container__list"
            @open-event-add-setting="openAddSettingPopup"
            @open-event-detail="goEventSettingDetail"
          />
        </div>
        <div v-else class="event-no-data">
          <img src="@/assets/img/scmp/no_data.png" />
          <span>{{ t('label.noData') }}</span>
        </div>
      </div>
    </div>

    <div class="container-event" v-else>
      <div class="btn-add-setting">
        <lego-button border primary medium @click="toggleAddEventModal(true)"
          >{{ t('button.addEventPolicy') }}
        </lego-button>
      </div>
      <SetLogEvent :value="'Event'" />
    </div>

    <event-add-modal
      v-if="openAddEventModal"
      :product-type-code="productTypeCode"
      :selected-target="selectedTarget"
      @close="onCloseAddEventModal"
      @confirm="toggleAddEventModal(false)"
    />
    <event-detail-modal
      ref="eventDetailModal"
      v-if="eventDetailModalOpen && eventDetailModalParams"
      :title="t('menu.eventPolicyDetails')"
      :resource-type="eventDetailModalParams.resourceType"
      :seq="eventDetailModalParams.eventPolicyId"
      @open-event-edit-modal="openEventEditModal"
      @close="handleCloseModalDetail"
    />
    <event-edit-modal
      v-if="eventEditModalOpen && eventDetailModalParams"
      :title="t('menu.modifyEventSettings')"
      :resource-type="eventDetailModalParams.resourceType"
      :seq="eventDetailModalParams.eventPolicyId"
      @close="closeEditEventModal"
    />
  </div>
</template>

<script>
import _ from 'lodash';
import i18nMixin from '@/mixins/i18n.mixin.js';
import monTargetMixin from './monTarget.mixin.js';
import moment from 'moment';
import SetLogEvent from '@/containers/popup/components/SetLogEvent.vue';
import MonTargetEventDetailPopup from '@/containers/popup/MonTargetEventDetailPopup.vue';
import Event from '@/containers/event/common/Event.vue';
import EventLevel from '@/containers/event/common/ListEventLevel.vue';
import EventEditModal from '../event/eventSettings/EventEditModal.vue';
import EventDetailModal from '../event/eventSettings/EventDetailModal.vue';
import eventModalMixin from '../../mixins/eventModal.mixin';
import EventAddModal from '../event/eventSettings/EventAddModal';
import legoEventBus from '@/lego-component/utils/eventBus/eventBus';

export default {
  name: 'MonTargetEvent',
  props: {
    params: {
      type: Object,
      default: () => {}
    },
    initailEventId: {
      type: String,
      default: ''
    },
    scrollHeight: {
      type: String,
      default: ''
    },
    searchDate: {
      type: Object,
      default: () => {}
    }
  },
  mixins: [i18nMixin, monTargetMixin, eventModalMixin],
  components: {
    EventDetailModal,
    EventEditModal,
    SetLogEvent,
    MonTargetEventDetailPopup,
    Event,
    EventLevel,
    EventAddModal
  },
  emits: ['close', 'open-event-add-setting'],
  watch: {
    searchDate: {
      deep: true,
      immediate: true,
      handler(value, oldValue) {
        this.onSearchDataChange(value, oldValue);
      }
    },
    eventEditModalOpen(open) {
      // hidden body scroll when show modal <event-edit-modal />
      const body = document.getElementsByTagName('body');
      if (open) {
        body[0].style.overflow = 'hidden';
      } else {
        body[0].style.overflow = 'auto';
      }
    },
    eventLevelActive: {
      deep: true,
      handler(arrLevel) {
        legoEventBus.$emit('click-outside-datePicker');

        if (arrLevel.includes(this.$const.EVENT_LEVEL.ALL)) {
          this.lstEventState = this.eventList;
        } else {
          this.lstEventState = this.eventList.filter((event) =>
            arrLevel.includes(event.eventLevel)
          );
        }

        this.activeEventState();
      }
    }
  },

  data() {
    return {
      selectedValue: '2',
      isLoadingData: false,
      isEventDetailPopup: false,
      isEventData: true,
      modalParam: {},
      eventList: [],
      productId: '',
      eventId: '',
      productResourceId: '',
      productTypeCode: '',
      productName: '',
      policyId: '',
      eventStartDate: '',
      startDate: '',
      eventState: 'ACTIVE',
      hasEventPolicesData: false,
      finishGetData: false,
      getEventData: false,
      isProductAuth: true,
      eventLevelActive: [this.$const.EVENT_LEVEL.ALL],
      lstEventState: [],
      eventIdSelected: '',
      openAddEventModal: false,
      selectedTarget: {
        targets: []
      }
    };
  },
  close() {
    this.$emit('close', true);
  },
  created() {},
  mounted() {
    this.modalParam = this.params;
    this.productId = this.params.productId;
    this.productResourceId = this.params.productResourceId;
    this.productTypeCode = this.params.productTypeCode;
    this.productName = this.params.productName;
    this.startDate = this.params.startDate;
    this.selectedValue = this.params.isInActive ? 1 : 2;

    // 탭 권한 체크
    this.checkAuthorization(this.productResourceId, this.productTypeCode);
  },
  methods: {
    getEventFillter(lstEvent) {
      if (this.eventLevelActive.length && this.eventLevelActive[0] != this.$const.EVENT_LEVEL.ALL) {
        lstEvent = lstEvent.filter((item, idx) => this.eventLevelActive.includes(item.eventLevel));
      }

      return lstEvent;
    },
    toggleAddEventModal(openOrClose) {
      this.selectedTarget.targets = [];
      openOrClose &&
        this.selectedTarget.targets.push({
          ...this.modalParam,
          productSq: this.modalParam.productSq ?? this.modalParam.productId,
          label: this.modalParam.productName,
          value: this.modalParam.productName
        });
      this.openAddEventModal = openOrClose;
    },
    onCloseAddEventModal() {
      this.openAddEventModal = false;
    },
    activeEventState() {
      let position = 0;
      let top = 0;
      let tmpEvent = {};

      if (this.eventIdSelected) {
        this.lstEventState.forEach((event, idx) => {
          event.check = false;
          if (event.eventId == this.eventIdSelected) {
            event.check = true;
            tmpEvent = event;
            position = idx;
          }
        });
      }

      if (_.isEmpty(tmpEvent) && this.lstEventState && this.lstEventState.length) {
        this.lstEventState.forEach((event, idx) => {
          event.check = false;
        });
        this.lstEventState[0].check = true;
        this.eventIdSelected = this.lstEventState[0].eventId;
        tmpEvent = this.lstEventState[0];
      }

      this.setModalParam(tmpEvent);

      top = position == 0 ? (position * 100) / 2 : (position * 100) / 2 + 50;

      this.scrollTo(top);
    },
    scrollTo(top) {
      this.$nextTick(() => {
        if (this.$refs.cscroll) {
          const scrollElement = this.$refs.cscroll.scrollElement;
          scrollElement.scrollTop = top;
        }
      });
    },
    setActiveEvent(index) {
      this.lstEventState.forEach((event, idx) => {
        event.check = false;

        if (index == idx) {
          this.eventIdSelected = event.eventId;
          event.check = true;
        }
      });
    },
    onClickDetail(item, index) {
      this.setActiveEvent(index);

      this.setModalParam(item);
      legoEventBus.$emit('click-outside');
      legoEventBus.$emit('click-outside-datePicker');
    },
    setModalParam(item) {
      this.modalParam = {
        projectId: item.projectId,
        productId: item.productSq,
        eventId: item.eventId,
        productResourceId: item.productResourceId,
        productTypeCode: item.productTypeCode,
        productName: item.productName,
        policyId: item.eventPolicyId,
        startDate: item.eventStartDate
      };
    },
    // 탭 권한 체크
    checkAuthorization(productResourceId, productTypeCode) {
      let params = {
        productResourceIds: [productResourceId],
        actionName: 'MonitorView'
      };
      this.$http.product
        .checkProductAuthorization(params, productTypeCode, true)
        .then(async (res) => {
          this.isProductAuth = true;
          this.getEventPolices();
        })
        .catch((error) => {
          if (error && error.code == 'AccessDenied') {
            this.isProductAuth = false;

            this.$alert(error, async () => {
              this.getEventPolices();
            });
          }
        });
    },

    // refresh 데이터 정보 변경
    onSearchDataChange(value, oldValue) {
      if (value == oldValue || value === undefined || this.productResourceId === '') {
        return;
      }
      this.getEventPolices();
    },

    openEventDetailmodal() {
      this.modalParam = {
        projectId: this.params.projectId,
        productId: this.productId,
        eventId: this.eventId,
        productResourceId: this.productResourceId,
        productTypeCode: this.productTypeCode,
        productName: this.productName,
        policyId: this.policyId,
        startDate: this.eventStartDate
      };
    },

    // 이벤트 데이타조회
    searchEvent() {
      let params = {
        eventState: this.eventState,
        queryStartDt: this.getSearchDate().queryStartDt,
        queryEndDt: this.getSearchDate().queryEndDt
      };
      this.eventList = [];

      this.apiGetProductEvents(params, this.productResourceId, this.productTypeCode, true)
        .then(async (data) => {
          if (this.$util.isNotEmpty(data)) {
            if (data.totalCount > 0) {
              this.isEventData = true;
              this.eventList = [...data.contents];
              let ischeck = false;
              let initialIndex = 0;

              if (!this.isProductAuth) {
                this.eventList = [];
              }

              this.lstEventState = this.getEventFillter(this.$util.deepCopy(this.eventList));

              this.lstEventState.forEach((event, idx) => {
                event.check = false;

                if (event.eventId == this.eventIdSelected || event.eventId == this.initailEventId) {
                  ischeck = true;
                  initialIndex = idx;
                  event.check = true;
                }
              });

              if (!ischeck && this.lstEventState.length && initialIndex == 0) {
                this.lstEventState[0].check = true;
                this.setModalParam(this.lstEventState[0]);
              } else if (ischeck) {
                this.setModalParam(this.lstEventState[initialIndex]);
              }

              this.setActiveEvent(initialIndex);

              //상세정보 > 발행조건
              if (initialIndex > 0) {
                this.$nextTick(() => {
                  this.$refs.eventMessage &&
                    this.$refs.eventMessage[initialIndex].$el.scrollIntoView();
                });
              }

              let eventData = {
                eventId: data.contents[initialIndex].eventId,
                policyId: data.contents[initialIndex].eventPolicyId,
                startDate: data.contents[initialIndex].startDt
              };

              if (this.modalParam['eventId'] || this.modalParam['eventId'] == '000000') {
                this.eventId = eventData.eventId;
                this.modalParam['eventId'] = eventData.eventId;
              }

              this.onClick(eventData);
            } else if (data.totalCount === 0) {
              this.isEventData = true;
              await this.getEventPolices(false);
              this.lstEventState = [];
            } else {
              this.isEventData = false;
              this.lstEventState = [];
            }
          } else {
            this.isEventData = false;
          }
          this.getEventData = true;
        })
        .catch((err) => {
          this.eventList = [];
          if (err && err.code == 'AccessDenied') {
            this.isEventData = false;
          }
        })
        .finally(() => {
          this.isLoadingData = true;
        });
    },

    getEventPolices(hasGetdata = true) {
      let params = { productResourceIdList: [this.productResourceId] };
      this.apiPostEventPolicies(params, this.productTypeCode).then((data) => {
        if (data.contents.length) {
          this.hasEventPolicesData = true;
          if (hasGetdata) {
            if (this.selectedValue == 1) {
              this.fetchEventAll();
            } else {
              this.fetchEventActive();
            }
          }
        }
        this.finishGetData = true;
      });
    },

    setDuringSec(seconds) {
      let duringSec = '';
      let day = 0;
      let hour = 0;
      let min = 0;
      let sec = 0;
      let dhour =
        Math.floor(seconds / 3600) < 10
          ? '0' + Math.floor(seconds / 3600)
          : Math.floor(seconds / 3600);
      if (dhour > 1) {
        day = Math.floor(dhour / 24);
        hour = dhour - day * 24;
      }
      min = Math.floor((seconds % 3600) / 60);
      sec = seconds % 60;

      if (day > 0) {
        duringSec = day + this.$t('label.day') + hour + this.$t('label.hour');
      } else {
        if (hour > 0) {
          duringSec = hour + this.$t('label.hour');
        }
      }
      duringSec += min + this.$t('label.minute') + sec + this.$t('label.seconds');
      return duringSec;
    },
    onClick(item) {
      this.policyId = item.policyId;
      this.eventId = item.eventId;
      this.eventStartDate = item.startDate;
    },
    // 조회시간 설정
    getSearchDate() {
      let queryStartDt,
        queryEndDt,
        dateType = 1;

      if (this.searchDate) {
        queryStartDt = this.searchDate.queryStartDt;
        queryEndDt = this.searchDate.queryEndDt;
        dateType = this.searchDate.dateType;
      }

      // Global CDN
      if (dateType === 1 && this.productTypeCode === 'CDN') {
        queryStartDt = moment(queryStartDt).add(-1, 'days').toISOString();
        queryEndDt = moment(queryEndDt).add(-1, 'days').toISOString();
      }

      return {
        queryStartDt,
        queryEndDt
      };
    },
    selectRow(idx, lstEvent) {
      this.setActiveEvent(idx);
      this.setModalParam(lstEvent);
    },
    fetchEventActive() {
      legoEventBus.$emit('click-outside-datePicker');
      this.eventState = 'ACTIVE';
      this.selectedValue = '2';
      this.searchEvent();
    },
    fetchEventAll() {
      legoEventBus.$emit('click-outside-datePicker');
      this.eventState = 'ALL';
      this.selectedValue = '1';
      this.searchEvent();
    },
    openAddSettingPopup(param, item) {
      this.$emit('open-event-add-setting', param, item);
    },
    handleCloseModalDetail() {
      this.eventDetailModalOpen = false;
    },
    goEventSettingDetail(policyId, productTypeCode, projectId = '') {
      this.setEventModalParams(policyId, productTypeCode, projectId);
      this.openEventDetailModal(false);
    },
    closeEditEventModal() {
      this.eventEditModalOpen = false;
      this.$refs.eventDetailModal.getDetailInfo();
    }
  }
};
</script>

<style lang="scss" scoped>
.event-no-data {
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #737a8c;
  height: 100%;
  flex-direction: column;

  img {
    margin-bottom: 12px;
  }
}

.container-event {
  display: block;
  width: 100%;

  .btn-add-setting {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    margin-bottom: 214px;
  }
}

.container__list {
  width: 100%;
  display: flex;
}

.container__list-event-left {
  .lego-segment-button :deep {
    .active svg path {
      fill: #2c59d9;
    }
  }

  :deep .event-item-container .wrapper {
    margin-right: 0 !important;
  }

  .gr-button-list {
    .lego-segment-wrapper {
      margin: 0 !important;

      button {
        width: 32px;
        min-width: auto !important;
        position: relative;

        i {
          position: absolute;
          top: 2px;
          left: 1px;
        }
      }
    }

    .btn-event-level {
      :deep .lego-segment-button--medium {
        min-width: 60px !important;
        width: auto !important;
      }
    }

    display: flex;
    justify-content: space-between;
    padding-right: 24px;
  }
}

.container {
  display: flex;
  flex: 1;
  padding: 16px 0px 12px 0px;

  &__list-event,
  &__list-event-left {
    width: 50%;
    border-right: 1px solid #e3e4e8;

    .events {
      margin-top: 8px;
    }
  }

  &__list-event-left {
    flex: 1 !important;
  }

  &__detail-event {
    width: 50%;
  }
}
</style>
